export enum FuelTypeUnitEnum {
    GNV = 'm3',
    GLP = 'm3',
    GASOLINA = 'gal',
    PETROLEO = 'gal',
    ELECTRICIDAD = 'KW'
}